import { render } from "./Admin.vue?vue&type=template&id=11cff10a&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=11cff10a&scoped=true&lang=css"

import exportComponent from "F:\\PWAs\\metavision-plural-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cff10a"]])

export default __exports__